import { Popover } from "antd";
import React, { useState, useContext } from "react";
import { MdPets } from "react-icons/md";
import { GrBike } from "react-icons/gr";
import { MdWineBar } from "react-icons/md";
import { AppContext } from "../../context";
import SmallModal from "../../components/SmallModal/SmallModal";
import TableWrapper from "../../components/Card/StyleWrappers";
import { FaTrailer, FaWineGlassAlt } from "react-icons/fa";
import { GiElectric } from "react-icons/gi";
import { BiFridge } from "react-icons/bi";

function TransportationCardContent({ product, context }) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  let info = useContext(AppContext);

  const popoverContent = (
    <div>
      <p>{product.request}</p>
    </div>
  );

  const selectComponent = () => {
    switch (context) {
      case undefined:
        return (
          <>
            <div className="card-body">
              <div className="short-description">
                {product.gen_description["pt-pt"]}
              </div>
              <Popover content="Veículo elétrico" title={null} trigger="hover">
                {product.tra_amenities?.includes("electric") && (
                  <GiElectric style={{ marginRight: "16px" }} />
                )}
              </Popover>
              <Popover
                content="Transporte de animais de estimação"
                title={null}
                trigger="hover"
              >
                {product.tra_amenities?.includes("pet_friendly") && (
                  <MdPets style={{ marginRight: "16px" }} />
                )}
              </Popover>
              <Popover
                content="Transporte de bicicletas"
                title={null}
                trigger="hover"
              >
                {product.tra_amenities?.includes("bike_carrier") && (
                  <GrBike style={{ marginRight: "16px" }} />
                )}
              </Popover>
              <Popover content="Mini-bar" title={null} trigger="hover">
                {product.tra_amenities?.includes("mini_bar") && <BiFridge />}
              </Popover>
              <Popover
                content="Reboque disponível"
                title={null}
                trigger="hover"
              >
                {product.tra_amenities?.includes("trailer") && <FaTrailer />}
              </Popover>
            </div>
          </>
        );
      case "cart":
      case "reservation":
      case "ticket":
      case "reservation-info":
      case "payment":
        return (
          // <TableWrapper>
          //   <table>
          //     <tr>
          //       <td>Data</td>
          //       <td>{product.date}</td>
          //     </tr>
          //     <tr>
          //       <td>Hora</td>
          //       <td>{product.time}</td>
          //     </tr>
          //     <tr>
          //       <td>Pessoas</td>
          //       <td>{product.people}</td>
          //     </tr>
          //     {product.gen_price !== 0 && (
          //       <tr>
          //         <td>Preço</td>
          //         <td>{product.gen_price}</td>
          //       </tr>
          //     )}{" "}
          //   </table>
          // </TableWrapper>
          <div>
            <div className="ahp-reservation-content">
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Data</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.transportation?.date?.toISOString().split("T")[0]
                    : product.date}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Hora</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.transportation?.time?.toString().slice(16, 25)
                    : product.time?.toString().slice(16, 25)}
                </div>
              </div>
              {/* <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Pessoas</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.transportation.people
                    : product.people}
                </div>
              </div> */}
              {/* <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Preço</div>
                <div className="ahp-reservation-value">
                  {product.gen_price} €
                </div>
              </div> */}
              {context !== "reservation-info" && product.request && (
                <div className="ahp-reservation-notes">
                  <Popover
                    content={popoverContent}
                    title="Notas"
                    trigger="click"
                  >
                    <a role="button" tabindex="0">
                      Notas
                    </a>
                  </Popover>
                </div>
              )}
            </div>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <>
      {product.gen_price !== null &&
        product.gen_price !== 0 &&
        context !== "ticket" &&
        context !== "reservation-info" &&
        context !== "payment" &&
        !(
          product.status === "not-available" || product.status === "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">{product.gen_price} €</div>
            <div
              className="ahp-price-info"
              onClick={() => setIsPriceModalVisible(true)}
            >
              i
            </div>
          </div>
        )}
      {selectComponent()}
      <SmallModal
        text="Preço de toda a reserva, para o número de pessoas e data selecionada."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
      />
    </>
  );
}

export default TransportationCardContent;
